import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getTrend } from '@/service/warehouse/spareParts';
// import { IRankItem } from '@/service/warehouse/spareParts/type';
export default function useStockTrend() {
  var trendData = ref([]);
  var params = ref({
    limit: 30,
    page: 1
  });
  var getTrendAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getTrend(params.value);
          case 2:
            data = _context.sent;
            if (data.data) {
              trendData.value = data.data;
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getTrendAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [trendData, getTrendAsync];
}